import Card from "@rio-cloud/rio-uikit/Card";
import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

interface CategoryCardSkeletonProps {
  barsCount?: number;
}

const BAR_WIDTHS = [90, 72, 55, 40, 25];

export default function CategoryCardSkeleton({ barsCount = 5 }: Readonly<CategoryCardSkeletonProps>) {
  const bars = Array.from({ length: Math.max(0, barsCount) }, (_, index) => ({
    key: `category-card-skeleton-${index}`,
    width: BAR_WIDTHS[index] ?? BAR_WIDTHS.at(-1),
  }));

  return (
    <Card className="padding-20 padding-x-15 padding-x-50-md">
      <span className="text-size-16 text-bold">
        <ContentLoader height={16} width={180} />
      </span>

      <div className="display-flex justify-content-between gap-15 margin-y-20">
        <div className="width-100pct" style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          {bars.map((bar) => (
            <div key={bar.key} className="position-relative width-100pct rounded-small bg-lighter">
              <ContentLoader height={30} width={`${bar.width}%`} className="display-block rounded-small" />
            </div>
          ))}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          {bars.map((bar) => (
            <div
              key={bar.key}
              className="display-flex align-items-center justify-content-end"
              style={{ height: "30px" }}
            >
              <ContentLoader height={14} width={90} />
            </div>
          ))}
        </div>
      </div>

      <div className="display-flex align-items-center gap-10">
        <ContentLoader height={34} width={150} />
        <ContentLoader height={34} width={150} />
      </div>
    </Card>
  );
}
